import { useNavigate } from "react-router-dom";

import { Button } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";

export const CancelButton = ({
  size = "sm",
  path,
  action,
  loading,
}: {
  size?: "xs" | "sm" | "md";
  path?: string;
  action?: () => void;
  loading?: boolean;
}) => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  return (
    <Button
      fill="outline"
      type="light"
      size={size}
      onClick={() => (action ? action() : path ? navigate(path) : navigate(-1))}
      loading={loading}
    >
      {language === "bn" ? "বাতিল করুন" : "Cancel"}
    </Button>
  );
};
